import { SidebarContainerStack } from './TopicsSidebar'
import { COLORS } from 'app-constants'
import { Divider, Stack, Typography } from '@mui/material'
import AutoGraph from '@mui/icons-material/AutoGraph'
import { TrendTopic } from 'api/model'
import { useState } from 'react'

const TrendTopicRow = ({
  trendTopic,
  setSelectedTrend,
  isSelected,
}: {
  trendTopic: TrendTopic
  setSelectedTrend: React.Dispatch<React.SetStateAction<TrendTopic | null>>
  isSelected: boolean
}) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Stack
      borderRadius="4px"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => setSelectedTrend(trendTopic)}
      sx={{
        cursor: 'pointer',
        width: '100%',
        background: isHovered || isSelected ? COLORS.JELLED_MID_BLUE_10_PERCENT : COLORS.PURE_WHITE,
      }}>
      <Typography
        p="4px"
        key={trendTopic.id}
        variant="pXS"
        sx={{
          color: COLORS.GRAY_1,
          width: '100%',
        }}>
        {trendTopic.name}
      </Typography>
    </Stack>
  )
}

const TrendsSidebar = ({
  trendTopics,
  setSelectedTrend,
}: {
  trendTopics: TrendTopic[]
  setSelectedTrend: React.Dispatch<React.SetStateAction<TrendTopic | null>>
}) => {
  return (
    <SidebarContainerStack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <AutoGraph />

        <Typography
          variant="h5"
          sx={{
            color: COLORS.GRAY_1,
          }}>
          Trend updates
        </Typography>
      </Stack>

      <Divider
        sx={{
          width: '100%',
          my: '12px',
          borderColor: COLORS.GRAY_5,
        }}
      />

      {trendTopics.length === 0 ? (
        <Typography
          variant="pXS"
          sx={{
            color: COLORS.GRAY_2,
          }}>
          No trend updates yet.
        </Typography>
      ) : (
        <Stack spacing="4px" width="100%">
          {trendTopics.map((trendTopic) => (
            <TrendTopicRow
              key={trendTopic.id}
              trendTopic={trendTopic}
              setSelectedTrend={setSelectedTrend}
              isSelected={false}
            />
          ))}
        </Stack>
      )}
    </SidebarContainerStack>
  )
}

export default TrendsSidebar
